import { PricingPlan, NavItem } from '@/types';

// 导航菜单配置
export const NAV_ITEMS: NavItem[] = [
  { label: '产品特性', href: '/#features' },
  { label: 'AI应用', href: '/apps' },
  { label: '定价方案', href: '/pricing' },
  { label: '安装教程', href: '/docs' },
  { label: 'AI编程训练营', href: '/learning' },
  { label: '常见问题', href: '/faq' },
  { label: '联系我们', href: '/contact' },
];

// 产品套餐配置
export const PRICING_PLANS: PricingPlan[] = [
  // Claude 产品系列
  {
    id: 'claude-carpool',
    name: '拼车',
    price: 658,
    features: [
      '拼车共享，超高性价比',
      'Claude全模型（含Opus 4.8）',
      '1M上下文窗口',
      '每日约$60使用额度',
      '稳定畅快的编程体验',
      '售后技术群答疑'
    ],
    limitations: [
      '账号为多人拼车共享',
      '无API调用权限'
    ],
    support: '售后技术群',
    dailyLimit: 60,
    description: '拼车共享账号，每日约$60额度，高性价比畅享Claude全模型',
    category: 'claude',
    badge: '🚗 拼车'
  },
  {
    id: 'claude-exclusive',
    name: '独享账号',
    price: 2380,
    recommended: true,
    features: [
      '独享整号，不与他人共享',
      'Claude全模型（含Opus 4.8）',
      '最多同时5个终端使用',
      '全模型访问权限',
      '每日无限制请求',
      '专属客服一对一支持'
    ],
    limitations: [],
    support: '专属客服一对一',
    description: '独享整个账号，每日无限制，多终端并发，适合重度与团队使用',
    category: 'claude',
    badge: '🏅 独享账号'
  },
  {
    id: 'claude-package',
    name: '流量包',
    price: 480,
    isPackage: true,
    totalQuota: 500,
    validDays: 90,
    features: [
      '$500总流量额度',
      '90天有效期(3个月)',
      '支持Claude全模型',
      '灵活使用，用完即止',
      '适合非连续性使用场景',
      '超高性价比'
    ],
    limitations: [
      '流量用完后需重新购买',
      '过期后剩余流量作废',
      '无API调用权限'
    ],
    support: '社区支持',
    description: '灵活流量包，$500额度3个月有效，按需使用，适合临时或非连续场景',
    category: 'claude',
    badge: '🎟️ 流量包'
  },

  // 国产GLM-5 产品系列
  {
    id: 'glm-coding-max',
    name: 'GLM Coding Max',
    price: 328,
    features: [
      '国产GLM-5模型',
      '1M上下文窗口',
      '专注编程辅助',
      '轻量级快速响应',
      '每日不限量(官网策略)',
      '中文编程优化',
      '国产化技术栈',
      '官方拼车服务'
    ],
    limitations: [
      '无API调用权限',
      '单模型访问',
      '无批量处理功能',
      '基础社区支持'
    ],
    support: '社区支持',
    dailyLimit: 15,
    description: '328官方拼车，国产高性价比AI编程助手，基于GLM-5技术，专注中文编程场景',
    category: 'glm',
    badge: '🇨🇳 官方拼车'
  },
  {
    id: 'glm-official-exclusive',
    name: 'GLM 官方独享',
    price: 469,
    recommended: true,
    features: [
      '智谱AI官方直供',
      '国产GLM-5模型',
      '1上下文窗口',
      '官方专属通道',
      '更稳定的服务保障',
      '官方技术支持',
      '中文编程优化',
      '国产化技术栈'
    ],
    limitations: [
      '需在官方平台购买',
      '按官方政策执行'
    ],
    support: '官方技术支持',
    dailyLimit: 30,
    description: '智谱AI官方直供渠道，享受官方专属服务和技术支持',
    category: 'glm',
    badge: '🏅 官方独享',
    externalUrl: 'https://www.bigmodel.cn/claude-code?ic=RC9KWDOT1I'
  },

  // Codex GPT-5 产品系列
  {
    id: 'gpt5-plus',
    name: '官方Plus',
    price: 150,
    features: [
      'OpenAI GPT-5 Plus账号',
      '20美刀官方额度',
      '直接帮忙代充服务',
      '全模型访问权限',
      'GPT-5/o1最新模型',
      'DALL-E图像生成',
      '高级语音模式'
    ],
    limitations: [
      '需配合科学上网使用',
      '按OpenAI官方政策执行',
      '无API调用权限'
    ],
    support: '代充技术支持',
    dailyLimit: 20,
    description: '150元代充20美刀，直接帮充OpenAI官方Plus账号，享受GPT-5全部功能',
    category: 'gpt5',
    badge: '🔥 官方代充'
  },
  {
    id: 'gpt5-pro',
    name: '官方Pro',
    price: 1600,
    recommended: true,
    features: [
      'OpenAI GPT-5 Pro账号',
      '200美刀官方额度',
      '直接帮忙代充服务',
      '全模型访问权限',
      'GPT-5/o1最新模型优先体验',
      'DALL-E图像生成',
      '高级语音模式',
      '优先访问新功能'
    ],
    limitations: [
      '需配合科学上网使用',
      '按OpenAI官方政策执行',
      '无API调用权限'
    ],
    support: '专属代充支持',
    dailyLimit: 200,
    description: '1600元代充200美刀，直接帮充OpenAI官方Pro账号，深度使用GPT-5强大功能',
    category: 'gpt5',
    badge: '🏆 专业代充'
  }
];

// 流量包方案配置
export const PACKAGE_PLANS: PricingPlan[] = [
  {
    id: 'package-basic',
    name: '流量包',
    price: 480,
    isPackage: true,
    totalQuota: 500,
    validDays: 90,
    features: [
      '500美刀总流量额度',
      '90天有效期(3个月)',
      '支持Claude全模型',
      '灵活使用，用完即止',
      '适合非连续性使用场景',
      '超高性价比'
    ],
    limitations: [
      '流量用完后需重新购买',
      '过期后剩余流量作废',
      '不支持API调用',
      '无技术支持服务'
    ],
    support: '社区支持',
    description: '灵活流量包，按需使用，适合轻度或临时使用场景',
    category: 'package',
    badge: '🎟️ 热销'
  }
];

// 企业定制方案配置
export const ENTERPRISE_PLANS: PricingPlan[] = [
  {
    id: 'enterprise',
    name: '企业定制方案',
    price: 0, // 定制价格
    customPrice: true,
    contactSales: true,
    isEnterprise: true,
    teamSize: '5+人研发团队',
    recommended: true,
    features: [
      '包含Max Plus全部功能',
      '专属客户经理服务',
      '定制化API集成方案',
      '团队管理和权限控制',
      '企业级安全保障',
      '多项目并行管理',
      '高级代码审查工具'
    ],
    enterpriseFeatures: [
      '私有化部署选项',
      '定制化工作流开发',
      '专业培训和技术指导',
      '7×24小时技术支持',
      '企业级SLA保障',
      '混合云部署架构',
      '企业级单点登录(SSO)',
      '高级权限管理系统',
      '数据治理和合规支持'
    ],
    limitations: [],
    support: '专属客户经理 + 技术团队',
    slaLevel: '99.9%以上可用性保障',
    description: '面向企业研发团队，提供AI编程助手完整解决方案，可根据团队规模和需求定制'
  }
];

// 联系方式配置
export const CONTACT_INFO = {
  phone: '18689477277',
  email: '386740421@qq.com',
  wechat: 'BigDevil-Liang',
  workingHours: '周一至周五 9:00-18:00',
  address: '浙江省杭州市临平区东湖街道星光街853号517室'
};

// 核心功能特性
export const CORE_FEATURES = [
  {
    icon: '🚀',
    title: '智能代码生成',
    description: '基于Claude技术，支持多种编程语言的智能代码生成'
  },
  {
    icon: '🔍',
    title: '错误诊断修复',
    description: '实时代码分析，快速定位和修复程序错误'
  },
  {
    icon: '⚡',
    title: '代码重构优化',
    description: '智能建议代码改进方案，提升代码质量和性能'
  },
  {
    icon: '🌍',
    title: '多语言支持',
    description: '支持Python、JavaScript、Java、C++等20+种编程语言'
  },
  {
    icon: '🔗',
    title: 'Git集成',
    description: '无缝集成Git工作流，智能提交信息和代码审查'
  },
  {
    icon: '🧠',
    title: '项目理解',
    description: '深度理解项目结构，提供上下文相关的编程建议'
  }
];

// 支持的编程语言
export const SUPPORTED_LANGUAGES = [
  'python', 'javascript', 'typescript', 'java', 'go', 'rust', 
  'cpp', 'csharp', 'php', 'ruby', 'swift', 'kotlin', 'scala',
  'html', 'css', 'sql', 'shell', 'yaml', 'json', 'xml'
];